import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SimilarWorkshopArea from "./SimilarWorkshopArea";

const scrollTop = () => { window.scrollTo({ top: 0, behavior: "smooth" }) }

function SoldOut(props) {

    return (
        <>
            <aside className="package-widget-style-2 sold-out-aside">

                <div className="widget-body">

                    <div className="soldout-message">

                        <i className="fa-solid fa-heart-crack fa-2xl"></i>
                        <p>Sorry, this workshop is <strong>sold out</strong>.</p>
                        <p>Places often come up due to cancellations - join the waiting list <Link to={`${process.env.PUBLIC_URL}/subscribe/${props.ctype}/${props.srcid}`} onClick={scrollTop}>here</Link></p>
                        <p>You might also be interested in these related/similar workshops:</p>
                        <SimilarWorkshopArea ctype={props.ctype} srcid={props.srcid} artforms={props.artforms} />
                    </div>
                </div>
            </aside>
        </>
    );
}

export default SoldOut;